import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "buttonText", "button"]
  static classes = ["expanded", "collapsed"]
  
  connect() {
    // Initialize to collapsed state
    this.contentTarget.classList.add(...this.collapsedClasses)
    this.contentTarget.classList.remove(...this.expandedClasses)
    
    // Check if content is actually overflowing and show/hide button accordingly
    this.checkOverflow()
  }
  
  checkOverflow() {
    if (this.hasButtonTarget) {
      // Check if the content is being truncated
      const isOverflowing = this.contentTarget.scrollHeight > this.contentTarget.clientHeight
      
      if (isOverflowing) {
        this.buttonTarget.classList.remove('hidden')
      } else {
        this.buttonTarget.classList.add('hidden')
      }
    }
  }
  
  toggle() {
    const isCollapsed = this.contentTarget.classList.contains(this.collapsedClasses[0])
    
    if (isCollapsed) {
      this.expand()
    } else {
      this.collapse()
    }
  }
  
  expand() {
    this.contentTarget.classList.remove(...this.collapsedClasses)
    this.contentTarget.classList.add(...this.expandedClasses)
    
    // Update button text if present
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = 'Show less'
    }
    
    // Rotate chevron if present
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = 'rotate(180deg)'
    }
  }
  
  collapse() {
    this.contentTarget.classList.remove(...this.expandedClasses)
    this.contentTarget.classList.add(...this.collapsedClasses)
    
    // Update button text if present
    if (this.hasButtonTextTarget) {
      this.buttonTextTarget.textContent = 'Show more'
    }
    
    // Reset chevron if present
    if (this.hasIconTarget) {
      this.iconTarget.style.transform = 'rotate(0deg)'
    }
  }
}